import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

export default function CallToAction({
    title,
    subtitle,
    chips = [], // [{ label, color, variant }]
    actions = null, // ReactNode (buttons, links, badges...)
    sx = {}
}) {
    return (
        <Box
            sx={{
                textAlign: 'center',
                py: 6,
                backgroundColor: '#f8f9fa',
                borderRadius: 8,
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                ...sx
            }}
        >
            {title && (
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {title}
                </Typography>
            )}
            {subtitle && (
                <Typography variant="body1" color="text.secondary" sx={{ mb: (chips.length || actions) ? 4 : 0, maxWidth: 600, mx: 'auto' }}>
                    {subtitle}
                </Typography>
            )}
            {(chips.length > 0 || actions) && (
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                    {chips.map((c, i) => (
                        <Chip key={i} label={c.label} color={c.color} variant={c.variant} />
                    ))}
                    {actions}
                </Box>
            )}
        </Box>
    );
}
